/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { OrderStatusItem } from '../../models/order-status-item';

export interface CustomerOrderStatusControllerFindOne$Params {

/**
 * Order status ID
 */
  id: number;
}

export function customerOrderStatusControllerFindOne(http: HttpClient, rootUrl: string, params: CustomerOrderStatusControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>> {
  const rb = new RequestBuilder(rootUrl, customerOrderStatusControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: OrderStatusItem;
      }>;
    })
  );
}

customerOrderStatusControllerFindOne.PATH = '/order/customer-status/{id}';
